import axios from "axios";
import {ENTITY_ID_PERMISSIONS} from "./Constants";
import {API_URL} from "../../modules/auth/core/_requests";

export const GENERIC_GET_ALL = "/api/generic/all";
export const GENERIC_GET_ONE = "/api/generic/one";
export const GENERIC_DELETE = "/api/generic/delete";
export const GENERIC_CREATE = "/api/generic/create";
export const GENERIC_UPDATE = "/api/generic/update";
export const GENERIC_SELECT_GET_ALL = "/api/genericSelect";
export const GET_ALL_PERMISSIONS = "/api/permissions";
export const USER = "/api/users";
export const UPLOAD_FILE = "/api/upload";
export const LIBRARY_MANAGEMENT = "/api/libraryManagement";
export const ATTENDANCE = "/api/attendance";
export const DASHBOARD_ADMIN = "/api/dashboard/admin";
export const DASHBOARD_FINANCE = "/api/dashboard/finance";
export const DASHBOARD_MANAGER = "/api/dashboard/manager";
export const DASHBOARD_SUPERVISOR = "/api/dashboard/supervisor";
export const SUPER_ADMIN_BILLING = "/api/super-admin/organizations";
export const SUPER_ADMIN_DASHBOARD = "/api/super-admin/dashboard";


export function genericGetAll(entityId, tableFilterData) {
    if (entityId === ENTITY_ID_PERMISSIONS) {
        return getAllPermissions();
    }
    return axios.get(API_URL + GENERIC_GET_ALL + "?entityId=" + entityId, {params: tableFilterData});
}

export function getAllPermissions() {
    return axios.get(API_URL + GET_ALL_PERMISSIONS);
}

export function genericGetOne(entityId, id) {
    return axios.get(API_URL + GENERIC_GET_ONE + "/" + id + "?entityId=" + entityId);
}

export function genericDelete(entityId, id) {
    return axios.delete(API_URL + GENERIC_DELETE + "/" + id + "?entityId=" + entityId);
}

export function genericSelectGetAll(entityId, filterField = null, filterValue = null) {
    const params = {entityId};
    if (filterField && filterValue) {
        params.filterField = filterField;
        params.filterValue = filterValue;
    }
    return axios.get(API_URL + GENERIC_SELECT_GET_ALL + "/all", {params});
}

export function getSelectGetDynamicData(entityId, inputValue, searchField) {
    return axios.get(API_URL + GENERIC_SELECT_GET_ALL + "/dynamic?entityId=" + entityId + "&searchField=" + searchField + "&search=" + inputValue);
}

export function apiGenericCreate(entityId, data, config) {
    return axios.post(API_URL + GENERIC_CREATE + "?entityId=" + entityId, data, config);
}

export function apiGenericUpdate(entityId, data, id, config) {
    return axios.post(API_URL + GENERIC_UPDATE + "?entityId=" + entityId + "&id=" + id, data, config);
}

export function apiPasswordUpdate(id, data) {
    return axios.post(API_URL + USER + "/password?userName=" + id, data);
}

export function apiUploadFile(type, formData, classId) {
    return axios.post(API_URL + UPLOAD_FILE + "?type=" + type + "&clazz=" + classId, formData);
}

export function apiLibraryIssueBook(formData) {
    return axios.post(API_URL + LIBRARY_MANAGEMENT + "/issue", formData);
}

export function apiLibraryReceiveBook(formData) {
    return axios.post(API_URL + LIBRARY_MANAGEMENT + "/receive", formData);
}

export function apiLibraryRetireBook(formData) {
    return axios.post(API_URL + LIBRARY_MANAGEMENT + "/retire", formData);
}

export function getWeekAttendance(clazzId, week) {
    return axios.get(API_URL + ATTENDANCE + "/weekAttendance" + "?clazz=" + clazzId + '&week=' + week);
}

export function apiPostSingleAttendance(data) {
    return axios.post(API_URL + ATTENDANCE + "/saveSingle", data);
}

export function apiPostAllAttendance(clazzId, date) {
    return axios.post(API_URL + ATTENDANCE + "/saveMultiple?clazzId=" + clazzId + "&date=" + date, null);
}

// Dashboard API calls
export function getAdminDashboard() {
    return axios.get(API_URL + DASHBOARD_ADMIN);
}

export function getActiveJobs() {
    return axios.get(API_URL + DASHBOARD_ADMIN + "/active-jobs");
}

export function getFinanceDashboard() {
    return axios.get(API_URL + DASHBOARD_FINANCE);
}

export function getManagerDashboard() {
    return axios.get(API_URL + DASHBOARD_MANAGER);
}

export function getSupervisorDashboard() {
    return axios.get(API_URL + DASHBOARD_SUPERVISOR);
}

export function getManagerTableMetrics() {
    return axios.get(API_URL + '/api/dashboard/manager/table-metrics');
}

export function getSupervisorTableMetrics() {
    return axios.get(API_URL + '/api/dashboard/supervisor/table-metrics');
}

export function getAdminTableMetrics() {
    return axios.get(API_URL + '/api/dashboard/admin/table-metrics');
}

export function getFinanceTableMetrics() {
    return axios.get(API_URL + '/api/dashboard/finance/table-metrics');
}

export function getJobCardBranchStats() {
    return axios.get(API_URL + '/api/dashboard/jobcard-branch-stats');
}

// Super Admin Billing APIs
export function getAllOrganizationsWithBilling() {
    return axios.get(API_URL + SUPER_ADMIN_BILLING + "/billing");
}

export function updateOrgBilling(orgId, billingData) {
    return axios.put(API_URL + SUPER_ADMIN_BILLING + "/" + orgId + "/billing", billingData);
}

export function getOrgPayments(orgId) {
    return axios.get(API_URL + SUPER_ADMIN_BILLING + "/" + orgId + "/payments");
}

export function recordOrgPayment(orgId, paymentData) {
    return axios.post(API_URL + SUPER_ADMIN_BILLING + "/" + orgId + "/payments", paymentData);
}

export function recordOrgPaymentBatch(orgId, batchData) {
    return axios.post(API_URL + SUPER_ADMIN_BILLING + "/" + orgId + "/payments/batch", batchData);
}

export function deleteOrgPayment(orgId, paymentId) {
    return axios.delete(API_URL + SUPER_ADMIN_BILLING + "/" + orgId + "/payments/" + paymentId);
}

export function getSuperAdminDashboard() {
    return axios.get(API_URL + SUPER_ADMIN_DASHBOARD);
}

export function getMonthlyOverview(billingMonth) {
    return axios.get(API_URL + SUPER_ADMIN_BILLING + "/monthly-overview", {params: {billingMonth}});
}
